"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootLayoutSagas = void 0;
var effects_1 = require("redux-saga/effects");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var LayoutState_1 = require("@/pages/common/states/LayoutState");
var RootSaga_1 = require("@/pages/common/sagas/RootSaga");
var StorageApi_1 = require("@/api/browser/StorageApi");
var WindowApi_1 = require("@/api/browser/WindowApi");
var LogoutApiSaga_1 = require("@/pages/common/sagas/api/LogoutApiSaga");
var UserAction_1 = require("@/pages/common/actions/UserAction");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var LoginSaga_1 = require("@/pages/common/sagas/LoginSaga");
var MegaMenuAction_1 = require("@/pages/common/actions/MegaMenuAction");
var debounceRace_1 = require("@/utils/debounceRace");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var MegaSearchSaga_1 = require("@/pages/common/sagas/MegaSearchSaga");
var SubscribeApiSaga_1 = require("@/pages/common/sagas/api/SubscribeApiSaga");
var responseToSubscribeState_1 = require("@/pages/common/transformers/responseToSubscribeState");
var SubscribeState_1 = require("@/pages/common/states/SubscribeState");
var BigPopupState_1 = require("@/pages/common/states/BigPopupState");
var EnquireSagaCall_1 = require("@/pages/search/sagas/EnquireSagaCall");
var DetailCallSaga_1 = require("@/pages/detail/sagas/DetailCallSaga");
var attribution_1 = require("@/api/browser/attribution");
var EnquireAction_1 = require("../actions/EnquireAction");
var getMobileTopMenuExpand = function (state) { return state.layout.megamenu.mobileMenuActive; };
var getAccountActive = function (state) { return state.layout.megamenu.accountActive; };
var getFavoriteActive = function (state) { return state.layout.megamenu.favoriteActive; };
var getMobileLangActive = function (state) { return state.layout.megamenu.mobileLangActive; };
var getSubscribeEmail = function (state) { return state.layout.megafoot.subscribeEmail; };
var getResourceIsSaleActive = function (state) { return state.layout.megamenu.isResourceSaleActive; };
var getResourceIsRentActive = function (state) { return state.layout.megamenu.isResourceRentActive; };
/**
 * Toggle Main Navigation menu (property search, new developements page ... ) in mobile
 */
var takeWatchTopMenu = function () {
    var activePanel;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(RootSaga_1.getActivePanelField)];
            case 1:
                activePanel = _a.sent();
                if (!(activePanel === LayoutState_1.ActivePanel.TOPMENU)) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setActivePanel(LayoutState_1.ActivePanel.NONE))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setActivePanel(LayoutState_1.ActivePanel.TOPMENU))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
};
var takeWatchLocalize = function () {
    var activePanel, shouldShowPopup;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(RootSaga_1.getActivePanelField)];
            case 1:
                activePanel = _a.sent();
                if (!(activePanel === LayoutState_1.ActivePanel.LOCALIZE)) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setActivePanel(LayoutState_1.ActivePanel.NONE))];
            case 2:
                _a.sent();
                return [3 /*break*/, 6];
            case 3: return [4 /*yield*/, effects_1.select(WindowApi_1.getShouldShowMenuPopup)];
            case 4:
                shouldShowPopup = _a.sent();
                if (!shouldShowPopup) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setActivePanel(LayoutState_1.ActivePanel.LOCALIZE))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [2 /*return*/];
        }
    });
};
var takeWatchSaves = function () {
    var activePanel, shouldShowPopup;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(RootSaga_1.getActivePanelField)];
            case 1:
                activePanel = _a.sent();
                if (!(activePanel === LayoutState_1.ActivePanel.SAVES)) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setActivePanel(LayoutState_1.ActivePanel.NONE))];
            case 2:
                _a.sent();
                return [3 /*break*/, 6];
            case 3: return [4 /*yield*/, effects_1.select(WindowApi_1.getShouldShowMenuPopup)];
            case 4:
                shouldShowPopup = _a.sent();
                if (!shouldShowPopup) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setActivePanel(LayoutState_1.ActivePanel.SAVES))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [2 /*return*/];
        }
    });
};
var takeWatchUser = function () {
    var activePanel, shouldShowPopup;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(RootSaga_1.getActivePanelField)];
            case 1:
                activePanel = _a.sent();
                if (!(activePanel === LayoutState_1.ActivePanel.USER)) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setActivePanel(LayoutState_1.ActivePanel.NONE))];
            case 2:
                _a.sent();
                return [3 /*break*/, 6];
            case 3: return [4 /*yield*/, effects_1.select(WindowApi_1.getShouldShowMenuPopup)];
            case 4:
                shouldShowPopup = _a.sent();
                if (!shouldShowPopup) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setActivePanel(LayoutState_1.ActivePanel.USER))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [2 /*return*/];
        }
    });
};
/**
 * Toggle Favorite menu (Favorite, Saved Properties, Recently Views ... )
 * Visible in search page
 * Desktop: right side
 * Mobile: full screen
 */
var takeWatchFav = function () {
    var activePanel;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(RootSaga_1.getActivePanelField)];
            case 1:
                activePanel = _a.sent();
                if (!(activePanel === LayoutState_1.ActivePanel.FAV)) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setActivePanel(LayoutState_1.ActivePanel.NONE))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setActivePanel(LayoutState_1.ActivePanel.FAV))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
};
var watchTopMenuToggle = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.takeEvery(LayoutAction_1.default.TOGGLE_SAVES, takeWatchSaves)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.takeEvery(LayoutAction_1.default.TOGGLE_LOCALIZE, takeWatchLocalize)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.takeEvery(LayoutAction_1.default.TOGGLE_USER, takeWatchUser)];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
/**
 * Make the navigation menu expandable
 */
var takeWatchMenuItem = function (action) {
    var item, index, menuItems, i, menuItemOpened, isMobile, link;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                item = action.payload;
                return [4 /*yield*/, effects_1.select(RootSaga_1.getMenuItemIndex, item)];
            case 1:
                index = _a.sent();
                return [4 /*yield*/, effects_1.select(RootSaga_1.getMenuItems)];
            case 2:
                menuItems = _a.sent();
                if (index === -1)
                    return [2 /*return*/];
                i = 0;
                _a.label = 3;
            case 3:
                if (!(i < menuItems.length)) return [3 /*break*/, 6];
                if (i === index)
                    return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setMenuItemOpened(i, false))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5:
                i = i + 1;
                return [3 /*break*/, 3];
            case 6: return [4 /*yield*/, effects_1.select(RootSaga_1.getMenuItemField, index)];
            case 7:
                menuItemOpened = _a.sent();
                if (!menuItemOpened) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setMenuItemOpened(index, false))];
            case 8:
                _a.sent();
                return [3 /*break*/, 13];
            case 9: return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setMenuItemOpened(index, true))];
            case 10:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.getIsMobileMd)];
            case 11:
                isMobile = _a.sent();
                if (!(!isMobile && item.children.length && item.children[0].link)) return [3 /*break*/, 13];
                link = item.children[0].link;
                return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, link)];
            case 12:
                _a.sent();
                _a.label = 13;
            case 13: return [2 /*return*/];
        }
    });
};
var watchDropDownItemToggle = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.takeEvery(LayoutAction_1.default.TOGGLE_MENUITEM, takeWatchMenuItem)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
/**
 * Update currency in Cookie, and reload page
 */
var watchSetCurrency = function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(LayoutAction_1.default.ON_SET_CURRENCY)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.call(StorageApi_1.setCurrencyCookie, payload)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.globalReload())];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
/**
 * Replace language code in url, and go to new URL
 * /en-us/property-search -> /zh-hk/property-search
 */
var watchSetLanguage = function () {
    var payload, languageDetail, availableLanguages, newUrl;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(LayoutAction_1.default.ON_SET_LANGUAGE)];
            case 1:
                payload = (_a.sent()).payload;
                languageDetail = payload;
                return [4 /*yield*/, effects_1.select(RootSaga_1.getAvailableLanguages)];
            case 2:
                availableLanguages = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.changeUrlWithLanguage, availableLanguages, languageDetail.id)];
            case 3:
                newUrl = _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.globalSetUrl(newUrl))];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
/**
 * Call API to login user, set User state to null,
 * Redirect to '/'
 */
var watchTopMenuLogoutClick = function () {
    var emptyUser;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 11];
                return [4 /*yield*/, effects_1.take(LayoutAction_1.default.ON_TOPMENU_LOGOUT_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setGlobalLoading(true))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.call(EnquireSagaCall_1.popEnquireFormFromLocalStorage)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.call(LogoutApiSaga_1.logoutApi)];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setGlobalLoading(false))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.select(LoginSaga_1.getEmptyUser)];
            case 6:
                emptyUser = _a.sent();
                return [4 /*yield*/, effects_1.put(UserAction_1.default.setUser(emptyUser))];
            case 7:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('logoutSuccess'))];
            case 8:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.onLogoutSuccess())];
            case 9:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setActivePanel(LayoutState_1.ActivePanel.NONE))];
            case 10:
                _a.sent();
                return [3 /*break*/, 0];
            case 11: return [2 /*return*/];
        }
    });
};
/**
 * Resume where the user left base on URL Hash
 * Eg. Use for facebook login redirect
 */
var watchResumeState = function () {
    var returnState;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(LayoutAction_1.default.RESUME_STATE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(RootSaga_1.getReturnState)];
            case 2:
                returnState = _a.sent();
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setReturnState(''))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.onReturnState(returnState))];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchSetCallOrEmail = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_WINDOW_SCROLL)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setCallOrEmailState(true))];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchMegaOnLoadInitImages = function () {
    var isMobile;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(WindowApi_1.getIsMobileMd)];
            case 2:
                isMobile = _a.sent();
                if (!isMobile) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_SET_MOBILE_TOPMENU_EXPAND)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [4 /*yield*/, effects_1.call(WindowApi_1.lazyLoadManualImages)];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchMegaMenuSetMobileMenuNoScroll = function () {
    var payload, isExpand;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_SET_MOBILE_TOPMENU_EXPAND)];
            case 1:
                payload = (_a.sent()).payload;
                isExpand = payload;
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setNoscroll(isExpand))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchMegaMenuToggle = function () {
    var isExpand;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_MOBILE_TOPMENU_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getMobileTopMenuExpand)];
            case 2:
                isExpand = _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.setMobileTopMenuExpand(!isExpand))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchMegaFavoriteToggle = function () {
    var isActive;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_FAVORITE_TOGGLE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getFavoriteActive)];
            case 2:
                isActive = _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.setFavoriteMenuActive(!isActive))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchMegaAccountToggle = function () {
    var isActive;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_ACCOUNT_TOGGLE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getAccountActive)];
            case 2:
                isActive = _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.setAccountMenuActive(!isActive))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchMegaMobileLangToggle = function () {
    var isActive;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_MOBILE_LANG_TOGGLE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getMobileLangActive)];
            case 2:
                isActive = _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.setMobileLangActive(!isActive))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var putOnHover = function (action) { return effects_1.call(function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, debounceRace_1.default([MegaMenuAction_1.default.MEGAMENU_SET_ALL_POPUP_ACTIVE], function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.put(action)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var watchMegaBuyHover = function () {
    var isMobile;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_BUY_HOVER)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.getIsMobileMd)];
            case 2:
                isMobile = _a.sent();
                if (isMobile)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, putOnHover(MegaMenuAction_1.default.setBuyPopupActive(true))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchMegaRentHover = function () {
    var isMobile;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_RENT_HOVER)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.getIsMobileMd)];
            case 2:
                isMobile = _a.sent();
                if (isMobile)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, putOnHover(MegaMenuAction_1.default.setRentPopupActive(true))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchMegaAgentHover = function () {
    var isMobile;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_AGENT_HOVER)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.getIsMobileMd)];
            case 2:
                isMobile = _a.sent();
                if (isMobile)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, putOnHover(MegaMenuAction_1.default.setAgentPopupActive(true))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchMegaAboutUsHover = function () {
    var isMobile;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_ABOUTUS_HOVER)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.getIsMobileMd)];
            case 2:
                isMobile = _a.sent();
                if (isMobile)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, putOnHover(MegaMenuAction_1.default.setAboutUsPopupActive(true))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchMegaResourceHover = function () {
    var isMobile;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_RESOURCES_HOVER)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.getIsMobileMd)];
            case 2:
                isMobile = _a.sent();
                if (isMobile)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, putOnHover(MegaMenuAction_1.default.setResourcesPopupActive(true))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchMegaMyAccountClick = function () {
    var isMobile, isGuest, isUnverify, lang, lang;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 15];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_MY_ACCOUNT_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.getIsMobileMd)];
            case 2:
                isMobile = _a.sent();
                if (!isMobile) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.onAccountMenuToggle())];
            case 3:
                _a.sent();
                return [3 /*break*/, 14];
            case 4: return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 5:
                isGuest = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.isUnverified)];
            case 6:
                isUnverify = _a.sent();
                if (!isGuest) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.onLoginClicked())];
            case 7:
                _a.sent();
                return [3 /*break*/, 14];
            case 8:
                if (!isUnverify) return [3 /*break*/, 11];
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 9:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, "/" + lang + "/account/resendverification")];
            case 10:
                _a.sent();
                return [3 /*break*/, 14];
            case 11: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 12:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, "/" + lang + "/profile/accountinfo")];
            case 13:
                _a.sent();
                _a.label = 14;
            case 14: return [3 /*break*/, 0];
            case 15: return [2 /*return*/];
        }
    });
};
var watchMegaFavoriteClick = function () {
    var isMobile, lang;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_FAVORITE_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.getIsMobileMd)];
            case 2:
                isMobile = _a.sent();
                if (!isMobile) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.onFavoriteMenuToggle())];
            case 3:
                _a.sent();
                return [3 /*break*/, 7];
            case 4: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 5:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, "/" + lang + "/profile/savedproperties")];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var watchMegaLogin = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_LOGIN_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.setMobileTopMenuExpand(false))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.onLoginClicked())];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchMegaLogout = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_LOGOUT_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.setMobileTopMenuExpand(false))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.onLogoutClicked())];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchMegaEmailClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_EMAIL_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.onContactClicked())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchMegaCallClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_CALL_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.onCallClicked())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var isValidEmail = function (email) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))
        return true;
    return false;
};
var watchMegaResourceSaleToggle = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_RESOURCE_FOR_SALE_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.setResourceIsSaleActive(true))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.setResourceIsRentActive(false))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchMegaResourceRentToggle = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_RESOURCE_FOR_RENT_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.setResourceIsSaleActive(false))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.setResourceIsRentActive(true))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchMobileResourcePopularDistrictClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_MOBILE_RESOURCE_POPULAR_DISTRICTS_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.setMobileResourcePopularDistrictActive(true))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchMobileResourcePopularBuildingClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_MOBILE_RESOURCE_POPULAR_BUILDINGS_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.setMobileResourcePopularBuildingActive(true))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchMobileResourceForSaleClick = function () {
    var isResourceIsSaleActive;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_MOBILE_RESOURCE_FOR_SALE_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getResourceIsSaleActive)];
            case 2:
                isResourceIsSaleActive = _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.setResourceIsRentActive(false))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.setResourceIsSaleActive(!isResourceIsSaleActive))];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchMobileResourceForRentClick = function () {
    var isResourceIsRentActive;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_MOBILE_RESOURCE_FOR_RENT_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getResourceIsRentActive)];
            case 2:
                isResourceIsRentActive = _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.setResourceIsSaleActive(false))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.setResourceIsRentActive(!isResourceIsRentActive))];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchMegaFootSubscribe = function () {
    var email, isValid, response, subscribeState;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 19];
                return [4 /*yield*/, effects_1.take(MegaMenuAction_1.default.MEGAMENU_ON_SUBSCRIBE_SUBMIT)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getSubscribeEmail)];
            case 2:
                email = _a.sent();
                return [4 /*yield*/, effects_1.call(isValidEmail, email)];
            case 3:
                isValid = _a.sent();
                if (!!isValid) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('megafoot_subscribe_failed_invalid_email', BigPopupState_1.BigPopupType.FAILED, '', 'invalidEmail'))];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.setSubscribeLoading(true))];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.call(SubscribeApiSaga_1.subscribeByEmailApi, email)];
            case 7:
                response = _a.sent();
                return [4 /*yield*/, effects_1.call(responseToSubscribeState_1.responseToSubscribeState, response)];
            case 8:
                subscribeState = _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.setSubscribeLoading(false))];
            case 9:
                _a.sent();
                if (!(subscribeState === SubscribeState_1.SubscribeState.SUCCESS)) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.put(MegaMenuAction_1.default.setSubscribeEmail(''))];
            case 10:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('megafoot_subscribe_success', BigPopupState_1.BigPopupType.SUCCESS, 'success', 'subscribeSuccess'))];
            case 11:
                _a.sent();
                return [3 /*break*/, 18];
            case 12:
                if (!(subscribeState === SubscribeState_1.SubscribeState.UNCONFIRM)) return [3 /*break*/, 14];
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('megafoot_subscribe_failed_unverified', BigPopupState_1.BigPopupType.QUESTION, 'failed', 'subscribeUnverified'))];
            case 13:
                _a.sent();
                return [3 /*break*/, 18];
            case 14:
                if (!(subscribeState === SubscribeState_1.SubscribeState.DUPLICATED)) return [3 /*break*/, 16];
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('megafoot_subscribe_failed_duplicated', BigPopupState_1.BigPopupType.FAILED, 'failed', 'subscribeDuplicated'))];
            case 15:
                _a.sent();
                return [3 /*break*/, 18];
            case 16: return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('megafoot_subscribe_failed_unknown', BigPopupState_1.BigPopupType.FAILED, 'failed', 'subscribeUnknown'))];
            case 17:
                _a.sent();
                _a.label = 18;
            case 18: return [3 /*break*/, 0];
            case 19: return [2 /*return*/];
        }
    });
};
var getEnquiry = function (state) { return state.enquire; };
var doCallToActionWhatsapp = function () {
    var enquireState, clickCode, whatsappUrl, languageCode, currentPage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setLoading(true))];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getEnquiry)];
            case 2:
                enquireState = _a.sent();
                return [4 /*yield*/, effects_1.call(attribution_1.newWhatsAppClickCode)];
            case 3:
                clickCode = _a.sent();
                return [4 /*yield*/, effects_1.call(DetailCallSaga_1.getWhatsappUrl, enquireState, '', clickCode)];
            case 4:
                whatsappUrl = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.windowOpen, whatsappUrl)];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 6:
                languageCode = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.getCurrentUrl)];
            case 7:
                currentPage = _a.sent();
                return [4 /*yield*/, effects_1.call(attribution_1.logWhatsAppClick, languageCode, {
                        code: clickCode,
                        referenceId: enquireState.current ? enquireState.current.referenceId : undefined,
                        page: currentPage,
                    })];
            case 8:
                _a.sent();
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setLoading(false))];
            case 9:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchLayoutWhatsAppClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(LayoutAction_1.default.ON_PURE_WHATSAPP_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doCallToActionWhatsapp)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var doCallToActionCall = function () {
    var enquireState, callPopup, title, tel, caption, body, isMobile;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setLoading(true))];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getEnquiry)];
            case 2:
                enquireState = _a.sent();
                callPopup = enquireState.replybar.callPopup;
                title = callPopup.callUsAt + " " + callPopup.callNumber;
                tel = enquireState.replybar.phone.value;
                caption = callPopup.callPopupTitle;
                body = callPopup.officeHours;
                return [4 /*yield*/, effects_1.select(WindowApi_1.getIsMobileMd)];
            case 3:
                isMobile = _a.sent();
                if (!isMobile) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.call(WindowApi_1.windowOpen, "tel:" + tel)];
            case 4:
                _a.sent();
                return [3 /*break*/, 8];
            case 5: return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('callPopup', BigPopupState_1.BigPopupType.CALLPOPUP, title, caption, 'close', body))];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setLoading(false))];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [2 /*return*/];
        }
    });
};
var watchLayoutCallClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(LayoutAction_1.default.ON_CALL_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doCallToActionCall)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var rootLayoutSagas = {
    watchTopMenuToggle: watchTopMenuToggle,
    watchDropDownItemToggle: watchDropDownItemToggle,
    watchSetCurrency: watchSetCurrency,
    watchSetLanguage: watchSetLanguage,
    watchTopMenuLogoutClick: watchTopMenuLogoutClick,
    watchResumeState: watchResumeState,
    watchSetCallOrEmail: watchSetCallOrEmail,
    watchMegaOnLoadInitImages: watchMegaOnLoadInitImages,
    watchMegaMenuSetMobileMenuNoScroll: watchMegaMenuSetMobileMenuNoScroll,
    watchMegaMenuToggle: watchMegaMenuToggle,
    watchMegaFavoriteToggle: watchMegaFavoriteToggle,
    watchMegaAccountToggle: watchMegaAccountToggle,
    watchMegaMobileLangToggle: watchMegaMobileLangToggle,
    watchMegaRentHover: watchMegaRentHover,
    watchMegaBuyHover: watchMegaBuyHover,
    watchMegaAboutUsHover: watchMegaAboutUsHover,
    watchMegaResourceHover: watchMegaResourceHover,
    watchMegaAgentHover: watchMegaAgentHover,
    watchMegaMyAccountClick: watchMegaMyAccountClick,
    watchMegaFavoriteClick: watchMegaFavoriteClick,
    watchMegaLogin: watchMegaLogin,
    watchMegaLogout: watchMegaLogout,
    watchMegaEmailClick: watchMegaEmailClick,
    watchMegaCallClick: watchMegaCallClick,
    watchMegaResourceSaleToggle: watchMegaResourceSaleToggle,
    watchMegaResourceRentToggle: watchMegaResourceRentToggle,
    watchMobileResourcePopularDistrictClick: watchMobileResourcePopularDistrictClick,
    watchMobileResourcePopularBuildingClick: watchMobileResourcePopularBuildingClick,
    watchMobileResourceForSaleClick: watchMobileResourceForSaleClick,
    watchMobileResourceForRentClick: watchMobileResourceForRentClick,
    watchMegaFootSubscribe: watchMegaFootSubscribe,
    megaSearchSagas: MegaSearchSaga_1.megaSearchSagas,
    watchLayoutWhatsAppClick: watchLayoutWhatsAppClick,
    watchLayoutCallClick: watchLayoutCallClick,
};
exports.rootLayoutSagas = rootLayoutSagas;
